import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { HashLink } from 'react-router-hash-link';

import { useHeaderColorState } from 'context/header-color';
import Burger from 'components/burger';
import Nav from 'components/nav';

import { ReactComponent as Logo } from 'svg/logo.svg';

import style from './style.module.css';

const Header = ({ children, sticky, routes }) => {
  const headerColor = useHeaderColorState();
  const [open, setOpen] = useState(false);

  const className = classNames(style.header, {
    [style['-sticky']]: sticky,
    [style['-fixed']]: !sticky,
    [style['-open']]: open,
    [style['-close']]: !open,
  });

  return (
    <header
      id="header"
      className={className}
      style={{
        '--header-bg': headerColor,
      }}
    >
      <div className={style.wrapper}>
        <div className={style['title-wrapper']}>
          <Burger
            className={`hide-desktop  ${style.burger}`}
            open={open}
            onClick={() => {
              setOpen(!open);
            }}
          />
          <HashLink to="/#site-medium" className={style.title}>
            <Logo />
          </HashLink>
        </div>
        <div className={style.actions}>
          <Nav
            routes={routes}
            open={open}
            onClick={() => {
              setOpen(false);
            }}
          />
          {children}
        </div>
      </div>
    </header>
  );
};

Header.propTypes = {
  sticky: PropTypes.bool,
  routes: PropTypes.arrayOf(PropTypes.shape({})),
  children: PropTypes.node,
};

Header.defaultProps = {
  sticky: true,
  routes: [],
  children: null,
};
export default Header;
